import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaLocationDot } from "react-icons/fa6";

export function CardSimple(data, image) {
  return (
    <Card>
      <Card.Img variant="top" src={image} />
      <Card.Body>
        <Card.Title style={{color: '#1f2937'}}>{data.title}</Card.Title>
        <Card.Text style={{color: '#1f2937', fontSize: 15, textAlign: 'justify'}}>{data.body}</Card.Text>
        <br/>
        <a href={data.url} class="btn btn-primary"><FaLocationDot/> {data.textButton}</a>
      </Card.Body>
    </Card>
  );
}
